// extracted by mini-css-extract-plugin
module.exports = {"swatchesContainer":"swatches_swatchesContainer__CnVlD","swatchItem":"swatches_swatchItem__yE7bX","swatchMore":"swatches_swatchMore__Y9vfl"};